<ng-template #itemdetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>{{ item_details.stockid }}</b><span [innerHTML]="item_details.name"></span> &nbsp;&nbsp;&nbsp;
			<a *ngIf="config.env.package == 'tires' || (config.env.package == 'beauty'  && !issalesman)" [routerLink]="'/inventory/view/'+item_details.stockid"><i class="pointer fa fa-edit"></i></a>
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<mat-card class="tire-card " *ngIf="item_details">
				<mat-card-title-group>
					<mat-card-title>
						<h3 [innerHTML]="cleanAndFormatHTML(item_details.descriptions.name)"></h3>
						<section class="section-small" [innerHTML]="cleanAndFormatHTML(item_details.descriptions.description)"></section>
					</mat-card-title>
					<div class="tire-image">
						<div class="tire-image-container" *ngIf="item_details.image_large">
							<img mat-card-lg-image src="{{ item_details.image_large }}" class="img img-responsive large-thumb" lazy>
						</div>
					</div>
				</mat-card-title-group>
				<mat-card-content class="padding-0">
					<mat-tab-group #tabPanel mat-align-tabs="start" color="accent">
						<mat-tab label="Overview">
							<div class="row">
								<div class="col-md-6">
									Features:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.features)"></span>
								</div>
								<div class="col-md-6">
									Benefits:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.benefits)"></span>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Attributes">
							<div class="row">
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Specs">
							<!-- <mat-form-field appearance="standard" *ngIf="!addingattribute" class="text-right">
								<mat-label>Search Attributes</mat-label>
								<input type="text" class="text-right m-0 p-0" matInput (input)="searchAttributes($event.target.value)" />
							</mat-form-field> -->

							<div class="row">
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #mmmodal let-modal>
	<div class="modal-header mm-modal-header" [class.mm-modal-header--complete]="promo && isPromoMixMatchComplete(promo)">
		<div class="mm-header-info">
			<span class="mm-header-stockid">{{ promo.itemdesc.stockid }}</span>
			<span class="mm-header-desc">{{promo.itemdesc.description }}</span>
			<ng-container *ngIf="promo && getNumberOfNonType1Intros(promo.intros) > 1">
				<span class="mm-header-groups-badge">
					{{ getNumberOfNonType1Intros(promo.intros) }} groups required — fill all before adding
				</span>
			</ng-container>
		</div>
		<div class="mm-header-trail">
			<div class="mm-header-complete" *ngIf="promo && isPromoMixMatchComplete(promo)">
				<mat-icon class="mm-header-complete__icon">check_circle</mat-icon>
				<span class="mm-header-complete__text">Complete — ready to add</span>
			</div>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
	</div>
	<div class="modal-body mm-modal-body text-dark d-flex p-0" [class.mm-modal-body--substituting]="showSubstitution">
		<div class="mm-main-content">

		<div class="alert alert-warning mm-disc-alert py-2 mb-0 mx-3 mt-3" *ngIf="promo?.has_discontinued_intro" role="alert">
			This promo includes discontinued item(s). Verify before adding to the order.
		</div>

		<div class="mm-top-bar">
			<details class="mm-intros-collapse">
				<summary class="mm-intros-collapse__summary">
					<span class="mm-intros-collapse__label">Included items</span>
					<mat-icon class="mm-intros-collapse__chev-mat" aria-hidden="true">expand_more</mat-icon>
				</summary>
				<div class="mm-top-intros mm-top-intros--collapsible">
					<ng-container *ngFor="let intro of promo.intros">
						<ng-container *ngIf="intro.type === '1' || intro.type === 1">
							<span class="mm-intro-pill" [class.mm-intro-pill--discontinued]="intro.discontinued == 1 || intro.discontinued === '1'">
								{{ intro.stockid }} — {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})
								<span *ngIf="intro.discontinued == 1 || intro.discontinued === '1'" class="badge bg-danger ms-1">DC</span>
							</span>
						</ng-container>
					</ng-container>
				</div>
			</details>
			<div class="mm-top-controls">
				<label class="mm-instock-toggle" title="Show only shades currently in stock">
					<input type="checkbox" [(ngModel)]="mmShowInStockOnly" (change)="applyMmInStockFilter()">
					<span>In stock only</span>
				</label>
			<mat-form-field appearance="outline" class="mm-qty-field">
				<mat-label>Packages</mat-label>
				<input matInput type="number" [(ngModel)]="promo.qty" (input)="setParent($event, promo)" class="text-right">
			</mat-form-field>
			<button class="btn btn-primary mm-add-btn" [disabled]="isCompleted(promo)" (click)="addMM(promo)">
				ADD TO ORDER
			</button>
			</div>
		</div>

		<div class="mm-scan-bar">
			<div class="mm-input-wrap">
				<mat-icon class="mm-input-icon">qr_code_scanner</mat-icon>
				<input class="mm-input" placeholder="Scan to select..." (keyup.enter)="searchPromos($event)">
			</div>
		</div>

		<div class="mm-groups-scroll" *ngIf="promo">
			<ng-container *ngFor="let intro of promo.intros">
				<div class="mm-group"
					*ngIf="intro.type != '1'"
					[class.mm-group--collapsed]="isGroupCollapsed(intro, promo.intros)"
					[class.mm-group--done]="isIntroMixMatchSatisfied(intro)">
					<button type="button"
						class="mm-group-header"
						[attr.aria-expanded]="!isGroupCollapsed(intro, promo.intros)"
						[attr.aria-controls]="'mm-group-body-' + (intro.mmid || intro.name)"
						(click)="toggleGroup(intro, promo.intros, $event)">
						<mat-icon class="mm-group-chev" aria-hidden="true">
							{{ isGroupCollapsed(intro, promo.intros) ? 'chevron_right' : 'expand_more' }}
						</mat-icon>
						<div class="mm-group-title">
							<b>{{ intro.name }} {{ intro.description }}</b>
						</div>
						<mat-icon *ngIf="isIntroMixMatchSatisfied(intro)" class="mm-group-done-icon" aria-hidden="true">check_circle</mat-icon>
						<div class="mm-group-progress" [ngClass]="{'mm-group-progress--done': isIntroMixMatchSatisfied(intro), 'mm-group-progress--error': intro.error}">
							<span [ngClass]="{'zero-quantity': getMMQtyUsed(intro) == 0}">{{ intro.dsptype }} {{ getMMQtyUsed(intro) | number }} / {{ intro.floor }}</span>
						</div>
					</button>

					<div class="mm-group-body" [id]="'mm-group-body-' + (intro.mmid || intro.name)">
						<div class="mm-search-bar">
							<div class="mm-input-wrap">
								<mat-icon class="mm-input-icon">search</mat-icon>
								<input class="mm-input" tabindex="1" placeholder="Search Mix &amp; Match..." [(ngModel)]="intro.searchQuery" (input)="filterItems(intro)" appCollapseKeyboard>
								<button class="mm-input-clear" *ngIf="intro.searchQuery" tabindex="-1" (click)="intro.searchQuery = ''; filterItems(intro)">
									<mat-icon>close</mat-icon>
								</button>
							</div>
						</div>

						<div class="mm-item-list">
							<div *ngIf="isGroupEmpty(intro)" class="mm-group-empty" role="status">
								<mat-icon class="mm-group-empty__icon" aria-hidden="true">info</mat-icon>
								<div class="mm-group-empty__text">
									<div class="mm-group-empty__title">No items available for this mix &amp; match</div>
									<div class="mm-group-empty__hint" *ngIf="intro?.searchQuery">
										Try clearing the search or toggling “In stock only”.
									</div>
									<div class="mm-group-empty__hint" *ngIf="!intro?.searchQuery && mmShowInStockOnly">
										All items are out of stock. Turn off “In stock only” to view them.
									</div>
									<div class="mm-group-empty__hint" *ngIf="!intro?.searchQuery && !mmShowInStockOnly">
										This mix &amp; match definition has no products mapped. Please check the promo configuration.
									</div>
								</div>
							</div>
							<ng-container *ngFor="let item of (intro.filteredItems ? intro.filteredItems : intro.items); trackBy: trackByStockId">
								<div class="mm-item-row" [ngClass]="{'mm-item-row--picked': item.quantity > 0, 'mm-item-row--discontinued': item.discontinued == 1 || item.discontinued === '1', 'mm-item-row--oos': getMmItemQoh(item) <= 0}">
									<div class="mm-item-info">
										<span class="mm-item-stockid">{{ item.stockid }}</span>
										<span *ngIf="item.discontinued == 1 || item.discontinued === '1'" class="badge bg-danger ms-1 align-middle">DC</span>
										<span *ngIf="getMmItemQoh(item) <= 0" class="mm-oos-badge">OOS</span>
										<span *ngIf="config.env.client !== 'aaprod' && getMmItemQoh(item) > 0" class="mm-qoh-badge">{{ getMmItemQoh(item) }} <small>qoh</small></span>
										<span class="mm-item-desc">{{ item.description }}</span>
									</div>
									<div class="mm-item-qty">
										<button mat-icon-button class="mm-qty-btn" (click)="decrementmm(item, intro)">
											<mat-icon>remove</mat-icon>
										</button>
										<input type="text" class="mm-qty-input" [value]="item.quantity | number" (input)="qtyMM($event, item, intro)">
										<button mat-icon-button class="mm-qty-btn" (click)="incrementmm(item, intro)">
											<mat-icon>add</mat-icon>
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
		</div>

		</div><!-- /.mm-main-content -->
		<div class="mm-sidepanel" *ngIf="mmSidePanel" [class.mm-sidepanel--substituting]="showSubstitution">
		<div class="mm-sidepanel-tools w-100" *ngIf="allow_mm_substitutes">
			<button class="w-100 sub-btn" mat-stroked-button color="primary" (click)="showSubstitution = !showSubstitution">
				<ng-container *ngIf="!showSubstitution">Substitute Item?</ng-container>
				<ng-container *ngIf="showSubstitution">Substituting...</ng-container>
			</button>
		</div>
		<div class="substituion-block" *ngIf="showSubstitution">
			<h5 class="mm-sub-section-title">Substitute with
					<mat-icon *ngIf="substituteItem" class="mm-sub-section-title__icon text-success">check_circle</mat-icon>
				</h5>
			<mat-form-field class="mm-sub-search-field w-100" appearance="outline" *ngIf="!substituteItem">
				<input placeholder="Scan barcode or enter SKU" matInput type="text" [formControl]="mmSubstituteRef">
				<svg *ngIf="subsearch" class="spinner subsearch" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</mat-form-field>
			<div *ngIf="substituteItemList.length && !substituteItem" class="mm-sub-pick-scroll">
				<div class="mm-sub-pick-list" role="list">
					<div *ngFor="let item of substituteItemList" class="mm-sub-pick-row" role="listitem">
						<div class="mm-sub-pick-info">
							<span class="mm-sub-pick-sku">{{ item.stockid }}</span>
							<span class="mm-sub-pick-desc">{{ item.description }}</span>
						</div>
						<button type="button" mat-stroked-button color="primary" class="mm-sub-pick-btn" (click)="substituteItem = item">Select</button>
					</div>
				</div>
			</div>
			<div class="mm-sub-picked-card" *ngIf="substituteItem">
				<div class="mm-sub-picked-card__head">
					<b class="mm-sub-picked-card__sku">{{ substituteItem.stockid }}</b>
					<button type="button" mat-icon-button class="text-danger mm-sub-picked-card__remove" (click)="substituteItem = false" aria-label="Clear selection">
						<mat-icon>close</mat-icon>
					</button>
				</div>
				<div class="mm-sub-picked-card__desc">{{ substituteItem.description }}</div>
			</div>
			<h5 class="mm-sub-section-title">Apply to group
				<mat-icon *ngIf="mmSubstituteGroupRef.value" class="mm-sub-section-title__icon text-success">check_circle</mat-icon>
			</h5>
			<mat-button-toggle-group class="m-auto mb-1 d-flex intro-sub-select" name="Intro" aria-label="Intro Selector" [formControl]="mmSubstituteGroupRef">
				<ng-container *ngFor="let int of promo.intros">
					<mat-button-toggle *ngIf="int.mmid" value="{{int.name}}">{{int.name}}</mat-button-toggle>
				</ng-container>
			</mat-button-toggle-group>
			<button mat-raised-button color="accent" (click)="getSub(mmSubstituteGroupRef.value)" class="w-100 mt-1" [disabled]="!mmSubstituteGroupRef.value || !substituteItem">
				Add Substitution
			</button>
		</div>
		<div class="selected-panel">
			<div class="mm-selected-scroll">
				<ng-container *ngFor="let item of mm_items_selected">
					<div *ngIf="item.quantity > 0" class="mm-selected-row" [class.mm-selected-row--dim]="showSubstitution" [class.mm-selected-row--sub]="item.substitute">
						<div class="mm-selected-top">
							<span class="mm-selected-stockid">{{ item.stockid }}</span>
							<div class="mm-selected-qty-controls">
								<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, item.quantity - 1)">
									<mat-icon>remove</mat-icon>
								</button>
								<input type="text" class="mm-qty-input" [value]="item.quantity" (change)="setter(item, +$event.target.value || 0)">
								<button type="button" mat-icon-button class="mm-qty-btn" (click)="setter(item, 1, true)">
									<mat-icon>add</mat-icon>
								</button>
							</div>
						</div>
						<div class="mm-selected-desc">{{ item.description }}</div>
						<div class="mm-selected-actions">
							<button type="button" mat-stroked-button color="warn" class="mm-selected-action mm-selected-action--remove" (click)="setter(item, 0)">Remove</button>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		</div><!-- /.mm-sidepanel -->
	</div><!-- /.modal-body -->
</ng-template>
<ng-template #edumodal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ event.name }} Registration - {{ event.location_name }} - {{event.date}}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				{{ event.short_description }}
			</div>
		</div>
		<br>
		<div class="row">
			<div class="col-3">
				<b>Host</b>
			</div>
			<div class="col-3">
				{{ event.host }}
			</div>
			<div class="col-3">
				<b>Presenter</b>
			</div>
			<div class="col-3">
				{{ event.artist_name }}
			</div>
		</div>
		<hr>
		<div class="row">
			<div class="col-3">
				<b>Cost Per Seat</b>
			</div>
			<div class="col-3">
				{{ event.discount | currency }}
			</div>
			<div class="col-3">
				<b>Capacity Remaining</b>
			</div>
			<div class="col-3">
				{{ event.remaining }} / {{ event.uses_total }}
			</div>
		</div>
		<hr>
		<form [formGroup]="regForm">
			<div class="row">

				<div class="col-2">
					<mat-form-field>
						<mat-label>Name</mat-label>
						<input matInput type="text" formControlName="eduname">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Cell Phone</mat-label>
						<input matInput mask="(000) 000-0000" [showMaskTyped]="true" type="text" formControlName="educell">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Email</mat-label>
						<input matInput mask="A*@A*.SSS" [validation]="true" [dropSpecialCharacters]="false" type="text" formControlName="eduemail">
					</mat-form-field>
				</div>
				<div class="col-2">
					<mat-form-field>
						<mat-label>Instagram</mat-label>
						<input matInput type="text" formControlName="eduinsta">
					</mat-form-field>
				</div>
				<div class="col-2">
					<button type="button" mat-stroked-button aria-label="Add" (click)="addSeat(event)" [disabled]="!regForm.valid"><mat-icon>add</mat-icon> Add Seat</button>
				</div>

			</div>
		</form>
		<hr>
		<div class="row" *ngFor="let seat of event.seats">
			<div class="col-2">
				{{ seat.name }}
			</div>
			<div class="col-2">
				{{ seat.cell }}
			</div>
			<div class="col-2">
				{{ seat.email }}
			</div>
			<div class="col-2">
				{{ seat.insta }}
			</div>
			<div class="col-2">
				<button type="button" mat-stroked-button aria-label="Add" (click)="remSeat(seat)"><mat-icon>remove</mat-icon></button>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<h4 class="modal-title">Total: {{ event.total | currency}}</h4>
		<button type="button" mat-stroked-button aria-label="Add" (click)="addedureg(event)" [disabled]="!event.seats.length"><mat-icon>add</mat-icon> Add To Order</button>
	</div>
</ng-template>
<div [ngClass]="isGridView ? '' : 'list-layout'">
	<ng-container *ngIf="isGridView">
		<div class="row">
			<ng-container *ngFor="let item of filtered_items; let i = index; trackBy: trackByStockId">
				<div class="col-12 col-md-6 col-lg-4">
					<div class="card mb-3">
						<img [src]="item.image_large" class="card-img-top" lazy>
						<div class="card-body" (click)="openModal(itemdetails, item)">
							<h5 class="card-title">{{ item.brand }}</h5>
							<p class="card-text">{{ item.description }}</p>
							<div *ngIf="!isdriver" class="d-flex justify-content-center flex-wrap gap-1 mt-2 compact-pills grid-card-qoh" (click)="$event.stopPropagation()">
								<app-qoh-popover [item]="item">
									<div class="compact-item pointer compact-item--pill">
										<span class="compact-pill-label">QOH</span>
										<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">{{ item.locqoh }}</span>
									</div>
								</app-qoh-popover>
								<ng-container *ngIf="config.env.client !== 'hairlines'">
									<div class="compact-item compact-item--pill">
										<span class="compact-pill-label">COM</span>
										<span class="compact-pill com-pill">{{ item.qos }}</span>
									</div>
									<div class="compact-item compact-item--pill">
										<span class="compact-pill-label">AVAIL</span>
										<span class="compact-pill avail-pill">{{ item.locqoh - item.qos }}</span>
									</div>
								</ng-container>
							</div>
						</div>
						<div class="card-footer text-muted">
							<div class="row p-0 m-0 text-center">
								<div class="col-auto mt-1 ml-auto mr-0 p-0 shrink-2">
									<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm " (click)="decrement(item)">
										<small><i class="material-icons">remove</i></small>
									</button>
								</div>
								<div class="m-0 p-0 the-dense-zone text-center" [ngClass]="filtersOpen ? 'col-4' : 'col-6 mw100'">
									<input type="text" tabindex="{{ i + 2 }}" pattern="[0-9]*" value="{{ item.quantity | number }}" autofocus (input)="updateSearchQuantity($event, item )" class="quantity-input col-auto">
								</div>
								<div class="col-auto mt-1 m-0 mr-0 p-0 shrink-2">
									<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
										<small><i class="material-icons">add</i></small>
									</button>
								</div>

								<div class="col-12 col-md-4 col-lg-4 ml-auto mb-0 mt-0 ml-auto mr-auto">
									<div [ngClass]="(item.quantity > 0) ? 'linetotal_row_picked' : 'linetotal_row'" class="row">
										<span class="linetotal_price">
											&nbsp;{{ getLineTotal(item) | currency }} &nbsp;
										</span>
										<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
											<small><i class="material-icons">add_box</i></small>
										</button>
										<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
											<small><i class="material-icons">settings</i></small>
										</button>
										<ng-container *ngIf="item.ispromo">
											<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
												<small><i class="material-icons">settings</i></small>
											</button>
											<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
												<small><i class="material-icons">add_box</i></small>
											</button>
										</ng-container>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
	<ng-container *ngIf="!isGridView">
		<ng-container *ngFor="let item of filtered_items; let i = index; trackBy: trackByStockId">
			<div class="row mt-0 mb-2 mb-lg-0 pt-0 pb-0 border-top text-center text-md-left compact-row">
				<div class="col-md-5 col-lg-5 ml-auto mr-auto ml-md-0 mr-md-0 p-0 mt-0 mb-0">
					<span class="bold pointer" (click)="openModal(itemdetails, item)">
						<span class="description">{{item.brand}} |&nbsp;</span> <span class="stock-id">{{ item.stockid }} |&nbsp;</span> <span class="brand">{{ item.description }}</span>
					</span>
				</div>
				<div class="col-md-2 col-lg-1 mt-0 p-0 text-center compact-info" [ngClass]="filtersOpen ? 'col-xl-1' : ''" *ngIf="!isdriver">
					<div class="d-flex justify-content-between align-items-center flex-fill compact-pills">
						<app-qoh-popover [item]="item">
							<div class="compact-item pointer compact-item--pill">
								<span class="compact-pill-label">QOH</span>
								<span class="compact-pill qoh-pill" [ngClass]="getQohPillClass(item.locqoh)">{{ item.locqoh }}</span>
							</div>
						</app-qoh-popover>
						<ng-container *ngIf="config.env.client !== 'hairlines'">
							<div class="compact-item compact-item--pill">
								<span class="compact-pill-label">COM</span>
								<span class="compact-pill com-pill">{{ item.qos }}</span>
							</div>
							<div class="compact-item compact-item--pill">
								<span class="compact-pill-label">AVAIL</span>
								<span class="compact-pill avail-pill">{{ item.locqoh - item.qos }}</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="col-12 col-sm-1 col-md-1 col-lg-1 ml-auto mr-auto mr-md-0 showqtys d-flex align-items-center justify-content-center salesman-special-slot">
					<div
						*ngIf="issalesman && item.specialflag"
						class="salesman-special-star"
						matTooltip="Special pricing"
						matTooltipPosition="above">
						<mat-icon aria-hidden="true">star</mat-icon>
					</div>
				</div>
				<div class="col-12 col-md-3 mt-0 ml-auto mr-auto">
					<div class="row p-0 m-0 text-center">
						<div class="col-auto mt-1 ml-auto mr-0 p-0 shrink-2">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm " (click)="decrement(item)">
								<small><i class="material-icons">remove</i></small>
							</button>
						</div>
						<div class="m-0 p-0 the-dense-zone text-center" [ngClass]="filtersOpen ? 'col-4' : 'col-6 mw100'">
							<input type="text" tabindex="{{ i + 2 }}" pattern="[0-9]*" value="{{ item.quantity | number }}" autofocus (input)="updateSearchQuantity($event, item )" class="quantity-input col-auto">
						</div>
						<div class="col-auto mt-1 m-0 mr-0 p-0 shrink-2">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="increment(item)">
								<small><i class="material-icons">add</i></small>
							</button>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2 col-lg-1 ml-auto mb-0 mt-0 ml-auto mr-auto">
					<div [ngClass]="(item.quantity > 0) ? 'linetotal_row_picked' : 'linetotal_row'" class="row">
						<span class="linetotal_price">
							&nbsp;{{ getLineTotal(item) | currency }} &nbsp;
						</span>
						<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addToOrder(item)" *ngIf="!item.ispromo && !item.isevent">
							<small><i class="material-icons">add_box</i></small>
						</button>
						<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerEdu(item)" *ngIf="item.isevent">
							<small><i class="material-icons">settings</i></small>
						</button>
						<ng-container *ngIf="item.ispromo">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
								<small><i class="material-icons">settings</i></small>
							</button>
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button" (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
								<small><i class="material-icons">add_box</i></small>
							</button>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</div>